<script>
import FooterBar from "@/components/Footer.vue";
import Information from "@/components/Information.vue";
import { onMounted, ref } from "vue";
import store from "@/store";
import { XlsxJson, XlsxRead, XlsxSheets, XlsxTable } from "vue3-xlsx";

export default {
  name: "Home",
  components: {
    Information,
    FooterBar,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    // XlsxWorkbook,
    // XlsxSheet,
    // XlsxDownload,
  },
  inject: ["GStore"],

  setup() {
    const tracers = ref(null); // Use ref to create a reactive variable
    const paragraphs = ref(null); // Use ref to create a reactive variable
    const tracersName = ref(""); // Use ref to create a reactive variable

    const fetchData = async () => {
      try {
        tracers.value = await store.dispatch("getTracers");
        paragraphs.value = await store.dispatch("getParagraphs");
        console.log(paragraphs.value, "paragraphs");
        console.log(tracers.value.tracers, "tracers");
        tracersName.value = tracers.value.tracers;
      } catch (error) {
        console.error("Error fetching tracers:", error);
      }
    };

    onMounted(fetchData);

    return { tracers, fetchData, tracersName, paragraphs };
  },

  data() {
    return {
      file: null,
      jsonCalculatorData: null,
      selectedSheet: "",
      sheetName: null,
      picked: "one",
      selectedTracer: "",
      selectedDevice: "",
      settingNr: 0,
      count: 1,
      response: ref(null),
      uploadedFileName: null,
    };
  },

  methods: {
    resetForm() {
      this.jsonCalculatorData = null;
      this.selectedTracer = "";
      this.selectedDevice = "";
      this.settingNr = 0;
      this.count = 1;
      this.uploadedFileName = null;
    },
    saveCollectionToLocalVariable(collection) {
      // Check if collection is not a promise and is an object
      if (typeof collection === "object" && !collection.then) {
        // Convert the object to a promise
        collection = Promise.resolve(collection);
      }

      collection
        .then((data) => {
          // Ensure data is an array
          if (Array.isArray(data)) {
            // Convert all keys to lowercase and the first value in each object
            // Save the transformed data to a local variable
            this.jsonCalculatorData = data.map((item) => {
              const lowercasedItem = {};
              for (const key in item) {
                lowercasedItem[key.toLowerCase()] =
                  key === Object.keys(item)[0]
                    ? item[key].toUpperCase()
                    : parseInt(item[key]);
              }
              return lowercasedItem;
            });
            let reqeust = this.jsonCalculatorData;
            console.log("Data", reqeust);
          } else {
            console.error("The resolved data is not an array.");
          }
        })
        .catch((error) => {
          console.error(
            "An error occurred while resolving the promise:",
            error
          );
        });
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },

    addSheet() {
      this.sheets.push({ name: this.sheetName, data: [...this.collection] });
      this.sheetName = null;
    },

    async calculate() {
      let request;
      if (this.jsonCalculatorData) {
        request = this.jsonCalculatorData;
      } else {
        request = [
          {
            tracer: this.selectedTracer,
            setting: parseInt(this.settingNr),
            count: parseInt(this.count),
          },
        ];
      }

      try {
        this.response = await this.$store.dispatch("calculate", {
          requestList: request,
        });
        this.resetForm();
      } catch (error) {
        console.error("Error fetching tracers:", error);
      }
    },
  },
};
</script>

<template>
  <div class="scrollable">
    <div>
      <br />
      <div class="container">
        <div class="row">
          <h1 class="vrm-page-title">Calculator</h1>

          <form class="vrm-form" @submit.prevent="calculate">
            <div class="radio-button-container">
              <input type="radio" id="one" value="one" v-model="picked" />
              <label for="one">Manual Input</label>
              <input type="radio" id="two" value="two" v-model="picked" />
              <label for="two">Upload Excel file</label>
            </div>
            <br />
            <div v-if="picked === 'one'">

              <!-- <div>
                <select v-model="selectedDevice">
                  <option disabled value="">Select a device</option>
                  <option v-for="device in deviceNames" :key="device" :value="device">
                    {{ device }}
                  </option>
                </select>
              </div>
              <br /> -->
              <div>
                <div>
                  <select v-model="selectedTracer">
                    <option disabled value="">Select a tracer</option>
                    <option v-for="tracer in tracersName" :key="tracer" :value="tracer">
                      {{ tracer }}
                    </option>
                  </select>
                </div>
                <br />
                <div class="radio-button-container">
                  <input type="radio" id="setting1" value="1" v-model="settingNr" />
                  <label for="one">Setting 1</label>
                  <input type="radio" id="setting2" value="2" v-model="settingNr" />
                  <label for="two">Setting 2</label>
                  <input type="radio" id="setting3" value="3" v-model="settingNr" />
                  <label for="two">Setting 3</label>
                </div>

                <div class="fieldset__item">
                  <label class="fieldset__item__label sg-textfield-label sg-required" for="count">
                    <span class="sg-textfield-label-caption">Count</span>
                  </label>
                  <input type="number" name="count" class="sg-element" v-model="count" min="1" max="9999" value />
                </div>

                <div class="vrm-panel--form__button-container"
                  v-if="picked && count !== 0 && settingNr && selectedTracer">
                  <button class="sg-btn sg-blue sg-element" type="submit" name="buttonLogin">
                    Calculate
                  </button>
                </div>
                <div v-if="this.response !== null">
                  <br />
                  <h1 v-if="this.response.requestList.length === 1">
                    {{ this.response.requestList[0].value }} ug
                  </h1>
                </div>
                <div class="flashMessage" v-if="GStore.flashMessage">
                  {{ GStore.flashMessage }}
                </div>
              </div>

            </div>
            <div v-else>
              <section>
                <div class="file-upload-container">
                  <label for="file-upload" class="file-upload-label">
                    <div class="upload-icon">
                      <i class="fa fa-upload"></i>
                    </div>
                    <div class="upload-text">Click or drag Excel file here</div>
                  </label>
                  <input type="file" id="file-upload" @change="onChange" ref="fileInput" accept=".xlsx"
                    style="display: none" />
                </div>
                <xlsx-read :file="file" v-if="file">
                  <xlsx-sheets>
                    <template #default="{ sheets }">
                      <br />
                      <div>
                        <select v-model="selectedSheet" v-if="sheets">
                          <option disabled value="">
                            Select an excel sheet
                          </option>
                          <option v-for="sheet in sheets" :key="sheet" :value="sheet">
                            {{ sheet }}
                          </option>
                        </select>
                      </div>
                      <br />
                    </template>
                  </xlsx-sheets>
                  <xlsx-table :sheet="selectedSheet" class="vrm-table vrm-table--admin" />
                  <xlsx-json :sheet="selectedSheet">
                    <template #default="{ collection }">
                      <br />
                      <div v-if="collection">
                        <button v-if="selectedSheet" class="sg-btn sg-blue sg-element" name="buttonExcel"
                          @click="saveCollectionToLocalVariable(collection)">
                          Calculate Excel
                        </button>
                      </div>
                    </template>
                  </xlsx-json>
                </xlsx-read>
              </section>
              <div v-if="this.response !== null">
                <br />
                <h1>
                  {{ this.response.requestList[0].value }} ug
                </h1>
              </div>
              <div class="flashMessage" v-if="GStore.flashMessage">
                {{ GStore.flashMessage }}
              </div>
            </div>
          </form>
        </div>
        <br />
        <div class="container" v-for="paragraph in paragraphs" :key="paragraph.id">
          <h1 class="vrm-page-title">{{ paragraph.paragraphTitle }}</h1>
          <p v-html="paragraph.paragraphText"></p>
        </div>

        <!-- <InformationComponent></InformationComponent> -->
      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<style lang="less">
/* Styling for the form container */

.file-upload-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: #f5f5f5;
  cursor: pointer;
}

.file-upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-icon {
  font-size: 24px;
  color: #007bff;
  margin-bottom: 8px;
}

.upload-text {
  font-weight: bold;
}

#file-upload {
  display: none;
}

/* Style for the file input when a file is being dragged over it */
.file-upload-container.drag-over {
  border-color: #007bff;
  background-color: #e0f2ff;
}

.vrm-form {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  background-color: #f5f5f5;
  border-radius: 5px;

  label {
    margin-bottom: 10px;
    font-weight: bold;
  }

  input[type="radio"] {
    margin-right: 10px;
    /* Add spacing here */
  }

  select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  input[type="number"] {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .fieldset__item {
    margin-top: 10px;
  }

  /* Styling for radio button container */
  .radio-button-container {
    display: flex;
    align-items: center;

    label {
      margin-right: 2rem;
      /* Adjust spacing between labels */
      margin-bottom: 0.1rem;
    }
  }
}

/* Styling for radio buttons */
input[type="radio"] {
  appearance: none;
  border: 2px solid #007bff;
  /* Change the color as needed */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;

  &:checked {
    background-color: #007bff;
    /* Change the color as needed */
  }
}

/* Styling for labels */
label {
  cursor: pointer;
}

/* Styling for submit button (if present) */
button[type="submit"] {
  background-color: #007bff;
  /* Change the color as needed */
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;

  &:hover {
    background-color: #0056b3;
    /* Change the color as needed */
  }
}
</style>
